import { createContext } from 'react';

import type { AdminDashboardContextValues } from './types';

export const AdmindashboardContext = createContext<AdminDashboardContextValues>(
  {
    currentUserOrganization: undefined,
    hasGamificationAvailable: false,
    hasProductDemoTest: false,
    hasRequestedDemoElevate: true,
    hasSeenWellcomeToElevate: true,
    hasSkillXpEvolutionAvailable: false,
    hasStudioAvailable: false,
    isBrazil: false,
    isCorporation: false,
    isTalent: false,
    name: '',
    openSnackbar: () => undefined,
    organizationId: 0,
    organizationLogo: null,
    slug: '',
    setNotificationDialogState: () => undefined,
    closeNotificationDialog: () => undefined,
    adminModules: [],
    isNonCentralizedUser: false,
    hasAdminModules: false,
    isLoading: false,
  },
);
